import React from 'react';
import { Path, Svg } from 'react-native-svg';

export interface LandmarkIconProps {
    size?: number;
    color?: string;
    strokeWidth?: number;
}

export function LandmarkIcon({ size = 24, color = '#333333', strokeWidth = 2 }: Readonly<LandmarkIconProps>) {
    return (
        <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <Path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M10 18v-7m4 7v-7m4 7v-7M3 22h18M6 18v-7m5.12-8.802a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.95-.22.95H3.474c-.53 0-.695-.717-.22-.95l7.866-3.853Z"
            />
        </Svg>
    );
}

export default LandmarkIcon;
